import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'neo-contenido-titulo',
  templateUrl: './contenido-titulo.component.html',
  styleUrls: ['./contenido-titulo.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ContenidoTituloComponent {

  @Input() class: string;

  @Input() titleTag: string;
  @Input() titleText: string;

  @Input() linkHref: string;
  @Input() linkTitle: string;
  @Input() linkTarget: string;
  @Input() linkRel: string;
}
